<template>
  <v-container v-if="factoring" justify="center" :style="{'margin-bottom': 0+'px',opacity: hidden?0.5:1}">
    <v-card align="center" style="width: 100%">
      <v-container>
        <v-row style="justify-content: center">
          <b><span>Byppay</span> </b>
        </v-row>
        <v-row>
          <v-col>
            <v-container class="pt-0 pb-0 pr-0">
              <v-row>
                <v-col style="text-align: start">
                  <div v-if="isRejected( factoring.status) && isRejectByMe(factoring.payer._id)">
                    <v-icon color="error">
                      mdi-close-circle-outline
                    </v-icon> {{ getFactoringPayer() }}
                  </div>
                  <div v-else-if="isAcceptedByMe(factoring.payer._id)">
                    <v-icon color="success">
                      mdi-check-circle-outline
                    </v-icon> {{ getFactoringPayer() }}
                  </div>
                  <div v-else>
                    {{ getFactoringPayer() }}
                  </div>
                </v-col>
              </v-row>
              <v-row style="padding:0;margin: 0">
                <v-col cols="auto" style="padding:0;margin: 0;text-align: left;align-self: center">
                  <i class="fas fa-arrow-down fa-2x iconGreen" style="padding: 0" />
                </v-col>
                <v-col style="text-align: left;padding: 0 0 0 5px;">
                  {{ factoring.compensatedPayerAmount }} €
                  <div>
                    <b>
                      <span v-if="statusAccepted"> {{ $t("Accepted") }}</span>
                      <span v-if="factoringPayed && !factoringPayedRecived"> {{ $t("Payed") }}</span>
                      <span v-if="factoringPayedRecived">{{ $t('Payment Accepted') }}</span>
                      <span v-else> {{ $t('Factoring.Waiting') }} </span>
                    </b>
                  </div>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col style="text-align: start">
                  <div v-if="isRejected( factoring.status ) && isRejectByMe(factoring.receiver._id)">
                    <v-icon color="error">
                      mdi-close-circle-outline
                    </v-icon> {{ getFactoringReceiver() }}
                  </div>
                  <div v-else-if="isAcceptedByMe(factoring.receiver._id)">
                    <v-icon color="success">
                      mdi-check-circle-outline
                    </v-icon> {{ getFactoringReceiver() }}
                  </div>
                  <div v-else>
                    {{ getFactoringReceiver() }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="auto" style="width: 130px">
            <v-progress-circular
              :rotate="-90"
              :size="100"
              :width="15"
              :value="compensationsPercentage"
              :color="percentageColor"
              style="left: 50%; transform: translateX(-50%);"
            >
              <v-btn color="primary" class="elevation-0" fab @click="dialog = true">
                <v-icon dark>
                  fa fa-info
                </v-icon>
              </v-btn>
            </v-progress-circular>
          </v-col>
        </v-row>
        <v-row v-if="amount!==-1" justify="center">
          <v-col class="pa-0">
            <p class="ma-0" style="font-weight: bold; margin-top: 2px;font-size: 15px;color: #FF6961">
              {{ $t("Outstanding Amount") }} {{ getOutstandingAmmount() }}{{ '€' }}
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-dialog v-model="dialog" scrollable style="margin: 5px" content-class="ml-1 mr-1" width="450">
      <v-card style="border-radius: 25px;border: 4px solid #000000;">
        <v-card-title class="justify-center background-color" style="text-align: center;color: #44E0B2">
          <span>{{ $t('Summary') }}</span>
          <v-icon style="position: absolute; right: 15px" large @click="dialog=false">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="background-color">
          <v-container class="pa-0">
            <v-row justify="center" style="padding-top: 8px">
              <v-col class="pa-1" cols="auto">
                <v-card align="center" height="40px" style="width: max-content;">
                  <v-card-title style="font-size: 15px; padding: 5px; width: max-content;">
                    <div v-if="isRejected( factoring.status) && isRejectByMe(factoring.payer._id)">
                      <v-icon color="error">
                        mdi-close-circle-outline
                      </v-icon> {{ getFactoringPayer() }}
                    </div>
                    <div v-else-if="isAcceptedByMe(factoring.payer._id)">
                      <v-icon color="success">
                        mdi-check-circle-outline
                      </v-icon> {{ getFactoringPayer() }}
                    </div>
                    <div v-else>
                      {{ getFactoringPayer() }}
                    </div>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col cols="auto" class="pa-1">
                <div style="width: max-content;">
                  <v-icon size="35px">
                    mdi-comment-arrow-right-outline
                  </v-icon>
                  <p style="font-weight: bold; margin-top: 2px;margin-bottom: 1px ;font-size: 15px;color: #43E1B2">
                    {{ getAmountFactoring() }}{{ '€' }}
                  </p>
                </div>
              </v-col>
              <v-col cols="auto" class="pa-1">
                <v-card height="40px" style="width: max-content;">
                  <v-card-title style="font-size: 15px;  padding: 5px; width: max-content">
                    <div v-if="isRejected( factoring.status ) && isRejectByMe(factoring.receiver._id)">
                      <v-icon color="error">
                        mdi-close-circle-outline
                      </v-icon> {{ getFactoringReceiver() }}
                    </div>
                    <div v-else-if="isAcceptedByMe(factoring.receiver._id)">
                      <v-icon color="success">
                        mdi-check-circle-outline
                      </v-icon> {{ getFactoringReceiver() }}
                    </div>
                    <div v-else>
                      {{ getFactoringReceiver() }}
                    </div>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="amount!==-1" justify="center">
              <p style="font-weight: bold; font-size: 15px;color: #FF6961">
                {{ $t("Outstanding Amount") }} {{ getOutstandingAmmount() }}{{ '€' }}
              </p>
            </v-row>
            <v-row justify="center">
              <v-alert
                elevation="0"
                dense
                style="background-color: unset"
                class="alertStatus pa-0 ma-0"
              >
                <span v-if="!statusCreated && !statusAccepted && !statusPayed && !statusRejected && !statusCanceled" style="font-size: 15px; color: black">{{ $t("Idle") }}</span>
                <!-- WAITING FOR ANSWERS BY THE PARTNERS -->
                <span v-if="statusCreated && iAmTheMiddle" style="font-size: 15px; color: black">
                  {{ $t("Waiting for your partners decision") }}
                </span>
                <!-- THE ACTUAL USER HAS NOT ANSWER -->
                <span v-if="statusCreated && !iAmTheMiddle" style="font-size: 15px; color: black">
                  <div v-if="isAcceptedByMe(factoring.payer._id)" style="text-align:center;"> {{ $user && factoring.payer._id.toString() === $user._id.toString() ? $t('Factoring.I ') : getFactoringPayer() }} {{ $t('Factoring.accepted the Byppay!') }}</div>
                  <div v-if="isAcceptedByMe(factoring.receiver._id) && !isSimpleFactoring()" style="text-align:center;">{{ $user && factoring.receiver._id.toString() === $user._id.toString() ? $t('Factoring.I ') : getFactoringReceiver() }} {{ $t('Factoring.accepted the Byppay!') }}</div>
                  <div v-if="iAmReceiver()" style="text-align:center;"> {{ $t("Waiting for your choice") }} </div>
                  <div v-if="iAmPayer()" style="text-align:center;"> {{ $t("Waiting for receiver choice") }} </div>
                </span>
                <!-- THE ACTUAL USER HAS ANSWER -->
                <span v-if="statusAccepted && iHaveAccepted" style="font-size: 15px; color: black">
                  <div v-if="isAcceptedByMe(factoring.payer._id)" style="text-align:center;"> {{ $user && factoring.payer._id.toString() === $user._id.toString() ? $t('Factoring.I ') : getFactoringPayer() }} {{ $t('Factoring.accepted the Byppay!') }}</div>
                  <div v-if="isAcceptedByMe(factoring.receiver._id) && !isSimpleFactoring()" style="text-align:center;">{{ $user && factoring.receiver._id.toString() === $user._id.toString() ? $t('Factoring.I ') : getFactoringReceiver() }} {{ $t('Factoring.accepted the Byppay!') }}</div>
                  <div style="text-align:center;">{{ $t("Waiting for your partners decision") }}.</div>
                </span>
                <!-- IM THE LAST ONE TO ANSWER -->
                <span v-if="statusAccepted && !iHaveAccepted" style="font-size: 15px; color: black">
                  <div v-if="isAcceptedByMe(factoring.payer._id)" style="text-align:center;"> {{ $user && factoring.payer._id.toString() === $user._id.toString() ? $t('Factoring.I ') : getFactoringPayer() }} {{ $t('Factoring.accepted the Byppay!') }}</div>
                  <div v-if="isAcceptedByMe(factoring.receiver._id) && !isSimpleFactoring()" style="text-align:center;">{{ $user && factoring.receiver._id.toString() === $user._id.toString() ? $t('Factoring.I ') : getFactoringReceiver() }} {{ $t('Factoring.accepted the Byppay!') }}</div>
                  <div style="text-align:center;">{{ $t("Waiting for your choice") }}</div>
                </span>
                <span v-if="statusCanceled" style="font-size: 15px; color: black">{{ $t("This bypay has been canceled") }}</span>
                <!--                FINAL STATE BYPPAY ACCEPTED-->
                <span v-if="statusPayed" style="font-size: 15px; color: black">
                  <div style="text-align:center;"> {{ $user && factoring.payer._id.toString() === $user._id.toString() ? $t('Factoring.I ') : getFactoringPayer() }} {{ $t('Factoring.accepted the Byppay!') }}</div>
                  <div v-if="!isSimpleFactoring()" style="text-align:center;"> {{ $user && factoring.receiver._id.toString() === $user._id.toString() ? $t('Factoring.I ') : getFactoringReceiver() }} {{ $t('Factoring.accepted the Byppay!') }}</div>
                  <div style="text-align:center;">{{ $t('Factoring.The final state of the bypay is:') }}</div>
                  <div style="text-align:center;word-break: break-word;"> <b>{{ $t("Accepted") }}</b>   <i class="far fa-check-circle iconGreen" style="color: green" /> </div>
                  <div style="text-align:center;word-break: break-word;"> <b>{{ $t('InvoiceStatus.Payed') }}</b>   <i v-if="factoringPayed" class="far fa-check-circle iconGreen" style="color: green" /></div>
                  <div style="text-align:center;word-break: break-word;"> <b>{{ $t('Payment Accepted') }} </b>  <i v-if="factoringPayedRecived" class="far fa-check-circle iconGreen" style="color: green" /></div>
                </span>
                <!--                FINAL STATE BYPPAY REJECTED-->
                <span v-if="statusRejected" style="font-size: 15px; color: black">
                  <div v-if="isRejectByMe(factoring.payer._id)" style="text-align:center;"> {{ $user && factoring.payer._id.toString() === $user._id.toString() ? $t('Factoring.I ') : getFactoringPayer() }} {{ $t('Factoring.rejected the Byppay!') }}</div>
                  <div v-if="isRejectByMe(factoring.receiver._id)" style="text-align:center;"> {{ $user && factoring.receiver._id.toString() === $user._id.toString() ? $t('Factoring.I ') : getFactoringReceiver() }} {{ $t('Factoring.rejected the Byppay!') }}</div>
                  <div v-if="isAcceptedByMe(factoring.payer._id)" style="text-align:center;"> {{ $user && factoring.payer._id.toString() === $user._id.toString() ? $t('Factoring.I ') : getFactoringPayer() }} {{ $t('Factoring.accepted the Byppay!') }}</div>
                  <div v-if="isAcceptedByMe(factoring.receiver._id)" style="text-align:center;">{{ $user && factoring.receiver._id.toString() === $user._id.toString() ? $t('Factoring.I ') : getFactoringReceiver() }} {{ $t('Factoring.accepted the Byppay!') }}</div>
                  <div style="text-align:center;">{{ $t('Factoring.The final state of the bypay is:') }}</div>
                  <div style="text-align:center;">{{ $t("Rejected") }}</div>
                </span>
              </v-alert>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="background-color">
          <v-container>
            <v-row justify="center">
              <v-col v-if="video" cols="12" align="center">
                <v-btn block class="elevation-0 btnSucces" @click="seeVideo = !seeVideo">
                  {{ $t("See related video") }}
                </v-btn>
              </v-col>
              <v-col v-if="(statusCreated && iAmTheReceiver) || (statusAccepted && !iHaveAccepted)" cols="6" align="center">
                <v-btn class="elevation-0 btnSucces" block @click="accept">
                  {{ $t("Accept") }}
                </v-btn>
              </v-col>
              <v-col v-if="statusPayed" cols="6" align="center">
                <v-btn block class="elevation-0 btnSucces" @click="go">
                  {{ $t("Go!") }}
                </v-btn>
              </v-col>
              <v-col v-if="(statusCreated && iAmTheMiddle) || (statusAccepted && iHaveAccepted)" cols="6" align="center">
                <v-btn color="error" block class="elevation-0" @click="remind">
                  {{ $t("Remind") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="seeVideo" scrollable style="margin: 5px" content-class="ml-1 mr-1" width="450">
      <v-card>
        <v-card-title class="justify-center background-color" style="text-align: center">
          <span>{{ $t('Video') }}</span>
          <v-icon style="position: absolute; right: 15px" large @click="seeVideo=false">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-container fluid class="pa-0">
            <v-row v-if="video && seeVideo" justify="center">
              <v-col cols="12">
                <div class="video-container">
                  <iframe id="iframe-video3" class="video-frame" :src="video" frameborder="0" allowfullscreen />
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <remindOptions ref="optionsModal" />
    <BypaySummary ref="bypaySummary" />
    <FactoringInformation ref="factoringInformation" />
  </v-container>
</template>

<script>
import Constants from "../../constants";
import ApiRepository from "../repositories/ApiRepository";
import {Factoring} from "../models/factoring";
import BypaySummary from "../components/BypaySummary";
import FactoringInformation from "../components/FactoringInformation";
import remindOptions from "../components/RemindOptions";


export default {
    name: "Factoring",
    components: { BypaySummary, remindOptions, FactoringInformation},
    props: {
        iFactoring: {type: Object, default: null},
        invoice: {type: Object, default: null},
        amount: { type: Number, default: null},
        show: { type: Boolean, default: null }
    },
    data () {
        return {
            hidden: false,
            factoring: null,
            factoringModel: null,
            invoiceAB: null,
            invoiceBC: null,
            dialog: false,
            video: null,
            seeVideo: false
        };
    },
    computed: {
        compensationsPercentage () {
            let percentage = 0;
            if (this.iFactoring.status === Constants.FACTORING.STATUS_REJECTED) {
                return ((Constants.FACTORING.STATUS_PAYED - 1) / 2) * 100;
            } else {
                percentage = ((this.iFactoring.status - 1) / 4) * 100;
                if (this.iFactoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_PAYED) {
                    percentage = percentage + 25;
                } else if (this.iFactoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_ACCEPTED) {
                    percentage = percentage + 50;
                }
                return percentage;
            }
        },
        percentageColor () {
            if (this.compensationsPercentage <= 0) {
                return "#3A5BA2";
            } else if (this.compensationsPercentage >= 100) {
                return "green";
            } else {
                return "#FFA74E";
            }
        },
        color () {
            return (this.$vuetify.theme.dark) ? "dark" : "light";
        },
        statusCreated () {
            if (this.factoring) {
                return this.factoring.status === Constants.FACTORING.STATUS_CREATED;
            }
            return false;
        },
        statusRejected () {
            if (this.factoring) {
                return this.factoring.status === Constants.FACTORING.STATUS_REJECTED;
            }
            return false;
        },
        statusCanceled () {
            if (this.factoring) {
                return this.factoring.status === Constants.FACTORING.STATUS_DISCARDED;
            }
            return false;
        },
        statusAccepted () {
            if (this.factoring) {
                return this.factoring.status === Constants.FACTORING.STATUS_ACCEPTED;
            }
            return false;
        },
        statusPayed () {
            if (this.factoring) {
                return this.factoring.status === Constants.FACTORING.STATUS_PAYED;
            }
            return false;
        },
        factoringPayed () {
          return this.iFactoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_PAYED || this.iFactoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_ACCEPTED;
        },
        factoringPayedRecived () {
          return this.iFactoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_ACCEPTED;
        },
        iAmTheMiddle () {
            return this.factoringModel && this.factoringModel.iAmTheMiddle();
        },
        iAmTheReceiver () {
            return this.factoringModel && this.factoringModel.iAmTheReceiver();
        },
        iHaveAccepted () {
            return this.factoringModel && this.factoringModel.iHaveAccepted();
        },
        rossumStatusUploaded () {
            return this.invoice.rossumStatus === Constants.ROSSUM.STATUS_UPLOADED;
        },
        canEdit () {
            return this.statusRejected || (!this.bypayDisabled || !this.forwardDisabled) || this.statusCanceled;
        }
    },
    watch: {
        dialog: function (newVal) {
            if (!newVal) {
                this.video = null;
            } else if (this.factoring.relatedVideoPath) {
                const fields = this.factoring.relatedVideoPath.split('/');
                const fileName = fields[2];
                this.video = "/api/video/" + fileName;
            }
        }
    },
    created () {
        this.fetch();
        this.dialog = this.show;
        this.hidden = this.factoringPayedRecived;
    },
    mounted () {
        if (this.dialog && this.statusPayed) {
            this.go();
        }
    },
    methods: {
        fetch () {
            this.factoring = this.iFactoring;
            if (this.factoring.relatedVideoPath) {
                const fields = this.factoring.relatedVideoPath.split('/');
                const fileName = fields[2];
                this.video = "/api/video/" + fileName;
            }
            if (this.$user && this.invoice.payerCif === this.$user.cif) {
                this.invoiceBC = this.invoice;
                this.invoiceAB = this.factoring.invoice_payer;
            } else {
                this.invoiceAB = this.invoice;
                this.invoiceBC = this.factoring.invoice_receiver;
            }
            this.factoringModel = new Factoring(this.factoring, this.$user, this.$parameters);
        },
        isSimpleFactoring () {
            return this.factoring.payer._id.toString() === this.factoring.receiver._id.toString();
        },
        getFactoringPayer () {
            return this.getNameUser(this.factoring.payer);
        },
        getFactoringReceiver () {
            if (this.isSimpleFactoring()) {
                return this.getNameUser(this.factoring.middle);
            } else {
                return this.getNameUser(this.factoring.receiver);
            }
        },
        getFactoringMiddle () {
            return this.getNameUser(this.factoring.middle);
        },
        getAmountFactoring () {
            return this.factoring.compensatedPayerAmount;
        },
        getOutstandingAmmount () {
            if (this.invoice._id.toString() === this.iFactoring.invoice_payer.toString()) {
                return Math.round(this.iFactoring.formulaCalc.ABout * 100) / 100;
            } else {
                return Math.round(this.iFactoring.formulaCalc.BCout * 100) / 100;
            }
        },
        getNameUser (user) {
            let name = "";
            if (user.name) {
                name = user.name;
                if (user.surname) {
                    if (name.length > 0) name += " ";
                    name += user.surname;
                }
            } else if (user.cif) {
                name = user.cif;
            } else {
                name = user.email;
            }
            return name;
        },
        accept () {
            if (!this.$user) {
                this.askLogin();
            } else if (!this.participateInvoce()) {
                this.changeAccount();
            } else {
                this.$router.push({
                    name: 'AcceptBypayes',  
                    query: {userId: this.factoring.middle._id.toString(), factoring: this.factoring._id.toString()}});
                // window.location.replace("#/acceptBypayes?userId=" + this.factoring.middle._id.toString() + "&");
                // const title = this.$t('Confirmation');
                // const message = this.$t('Do you want to accept this bypay?');
                // const button = false;
                // this.$root.$emit('show-confirmation-modal', {
                //     title: title,
                //     message: message,
                //     oneButton: button,
                //     yes: () => {
                //         this.$root.$emit('start-loading');
                //         this.$emit('startLoading');
                //         let nextStatus;
                //         if (this.factoringModel.iAmThePayer() && this.factoringModel.status() === Constants.FACTORING.STATUS_CREATED && this.factoringModel.isSimpleModel()) {
                //             nextStatus = Constants.FACTORING.STATUS_PAYED;
                //         } else if (((this.factoringModel.iAmThePayer()) || (this.factoringModel.iAmTheReceiver())) && this.factoringModel.status() === Constants.FACTORING.STATUS_CREATED) {
                //             nextStatus = Constants.FACTORING.STATUS_ACCEPTED;
                //         } else if ((this.factoringModel.iAmThePayer()) || (this.factoringModel.iAmTheReceiver()) && this.factoringModel.status() !== Constants.FACTORING.STATUS_CREATED) {
                //             nextStatus = Constants.FACTORING.STATUS_PAYED;
                //         }
                //
                //         if (this.factoringModel.isFactorModel()) {
                //             if (this.factoringModel.iAmThePayer()) {
                //                 nextStatus = Constants.FACTORING.STATUS_PAYED;
                //             } else {
                //                 nextStatus = Constants.FACTORING.STATUS_ACCEPTED;
                //             }
                //         }
                //         console.log(this.factoring._id);
                //         ApiRepository.updateFactoring(this.factoring._id, nextStatus)
                //             .then(() => {
                //                 this.$root.$emit('stop-loading');
                //                 this.$root.$emit('show-snackbar', {message: this.$t('Petition accepted successfully!')});
                //                 this.$emit('fetch');
                //                 this.dialog = false;
                //                 this.fetch();
                //             })
                //             .catch((err) => {
                //                 this.$root.$emit('stop-loading');
                //                 this.$root.$emit('show-snackbar', {
                //                     message: this.$t('Error accepting petition'),
                //                     color: 'error'
                //                 });
                //                 //this.$emit('fetch', {});
                //                 this.dialog = false;
                //                 console.error(err);
                //             });
                //     },
                // });
            }
        },
        participateInvoce () {
            return this.factoring.payer.cif === this.$user.cif || this.factoring.middle.cif === this.$user.cif || this.factoring.receiver.cif === this.$user.cif;
        },
        reject () {

            if (!this.$user) {
                this.askLogin();
            } else {
                const title = this.$t('Confirmation');
                const message = this.$t('Factoring.Do you want to reject this bypay?');
                const button = false;
                this.$root.$emit('show-confirmation-modal', {
                    title: title,
                    message: message,
                    oneButton: button,
                    yes: () => {
                        this.$root.$emit('start-loading');
                        this.$emit('startLoading');
                        let nextStatus = Constants.FACTORING.STATUS_REJECTED;

                        if (this.factoringModel.isFactorModel()) {
                            if (this.factoringModel.iAmThePayer())
                                nextStatus = Constants.FACTORING.STATUS_UNPAYED;
                            else
                                nextStatus = Constants.FACTORING.STATUS_REJECTED;
                        }
                        ApiRepository.updateFactoring(this.factoring._id, nextStatus)
                            .then(() => {
                                this.$root.$emit('stop-loading');
                                this.$root.$emit('show-snackbar', {message: this.$t('Petition rejected')});
                                this.$emit('fetch', {});
                                this.dialog = false;
                            })
                            .catch((err) => {
                                this.$root.$emit('stop-loading');
                                this.$root.$emit('show-snackbar', {
                                    message: this.$t('Error.Error rejecting petition'),
                                    color: 'error'
                                });
                                this.$emit('fetch', {});
                                this.dialog = false;
                                console.error(err);
                            });
                    },
                });
            }
        },
        getAllUrlParams (url) {

            // get query string from url (optional) or window
            let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

            // we'll store the parameters here
            const obj = {};

            // if query string exists
            if (queryString) {

                // stuff after # is not part of query string, so get rid of it
                queryString = queryString.split('#')[0];

                // split our query string into its component parts
                const arr = queryString.split('&');

                for (const element of arr) {
                    // separate the keys and the values
                    const a = element.split('=');

                    // set parameter name and value (use 'true' if empty)
                    let paramName = a[0];
                    let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

                    // (optional) keep case consistent
                    paramName = paramName.toLowerCase();
                    if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

                    // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                    if (paramName.match(/\[(\d+)?\]$/)) {

                        // create key if it doesn't exist
                        const key = paramName.replace(/\[(\d+)?\]/, '');
                        if (!obj[key]) obj[key] = [];

                        // if it's an indexed array e.g. colors[2]
                        if (paramName.match(/\[\d+\]$/)) {
                            // get the index value and add the entry at the appropriate position
                            const index = /\[(\d+)\]/.exec(paramName)[1];
                            obj[key][index] = paramValue;
                        } else {
                            // otherwise add the value to the end of the array
                            obj[key].push(paramValue);
                        }
                    } else if (!obj[paramName]) {
                        // if it doesn't exist, create property
                        obj[paramName] = paramValue;
                    } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                        // if property does exist and it's a string, convert it to an array
                        obj[paramName] = [obj[paramName]];
                        obj[paramName].push(paramValue);
                    } else {
                        // otherwise add the property
                        obj[paramName].push(paramValue);
                    }

                }
            }

            return obj;
        },

        go () {
            const urlParams = this.getAllUrlParams(window.location.href);
            if (!this.$user && typeof urlParams.me === 'undefined') {
                this.askLogin();
            } else {
                this.$refs.bypaySummary.show(this.invoiceAB, this.invoiceBC, this.factoring);
            }
        },
        remind () {
            if (!this.$user) {
                this.askLogin();
            } else {
                this.$refs.optionsModal.show(this.factoring._id);
            }
        },
        factoringInfo () {
            this.$refs.factoringInformation.show(this.invoice, this.factoring._id);
        },
        isRejected ( status ) {
            return status === Constants.FACTORING.STATUS_REJECTED;
        },
        isRejectByMe ( payer ) {
            return this.$user && this.factoring.rejectedBy === payer;
        },
        iAmReceiver () {
            return this.$user && this.$user._id.toString() === this.factoring.receiver._id.toString();
        },
        iAmPayer () {
            return this.$user && this.$user._id.toString() === this.factoring.payer._id.toString();
        },
        isAcceptedByMe ( user ) {
            if ( this.factoring.acceptedBy === Constants.ACCEPTED_FACTORING.ALL ) {
                return true;
            } else if ( this.factoring.acceptedBy === Constants.ACCEPTED_FACTORING.PAYER ) {
                return this.factoring.payer._id.toString() === user;
            } else if ( this.factoring.acceptedBy === Constants.ACCEPTED_FACTORING.RECEIVER ) {
                return this.factoring.receiver._id.toString() === user;
            }
            return false;
        },
        askLogin () {
            this.$root.$emit('show-confirmation-modal', {
                title: this.$t('Login'),
                message: this.$t('In order to do this option you need to login, Do you want to login?'),
                oneButton: true,
                yes: () => {
                    this.$router.push({name: 'Login', replace: true});
                }
            });
        },      
        changeAccount () {
            this.$root.$emit('show-confirmation-modal', {
                title: this.$t('Logout'),
                message: this.$t('In order to do this option you need to change the account, Do you want to change?'),
                oneButton: false,
                yes: () => {
                    this.$router.push({name: 'profile', replace: true});
                }
            });
        }
    },
    sockets: {
        REFRESH_BROWSE () {
            this.fetch();
        },
        REFRESH_payerPaymentToReceiver (event) {
            if (this.factoring._id.toString() === event.idFactoring) {
                this.factoring.payerPaymentToReceiver = event.newStatus;
                if (this.$refs.bypaySummary.isOpen()) {
                    this.$refs.bypaySummary.show(this.invoiceAB, this.invoiceBC, this.factoring);
                }
            }
        },
        REFRESH_middlePaymentToReceiverUpdate (event) {
            if (this.factoring._id.toString() === event.idFactoring) {
                this.factoring.middlePaymentToReceiverUpdate = event.newStatus;
                if (this.$refs.bypaySummary.isOpen()) {
                    this.$refs.bypaySummary.show(this.invoiceAB, this.invoiceBC, this.factoring);
                }
            }
        },
        REFRESH_middlePaymentToPlatformUpdate (event) {
            if (this.factoring._id.toString() === event.idFactoring) {
                this.factoring.middlePaymentToPlatformUpdate = event.newStatus;
                if (this.$refs.bypaySummary.isOpen()) {
                    this.$refs.bypaySummary.show(this.invoiceAB, this.invoiceBC, this.factoring);
                }
            }
        },
        REFRESH_payerPaymentToMiddleUpdate (event) {
            if (this.factoring._id.toString() === event.idFactoring) {
                this.factoring.payerPaymentToMiddleUpdate = event.newStatus;
                if (this.$refs.bypaySummary.isOpen()) {
                    this.$refs.bypaySummary.show(this.invoiceAB, this.invoiceBC, this.factoring);
                }
            }
        }
    },
};
</script>

<style scoped>
  .alertStatus div{
      white-space: pre-line;
      text-align: center;
  }
  .background-color {
    background-color: white !important;
  }
  .btnSucces{
    background-color: var(--v-btnSucces-base) !important;
    color: white !important;
  }
  .video-container {
    margin-top: 10px;
    width: 100%;
    flex-grow: 1;
    margin-bottom: 10px;
    height: fit-content;
    min-height: 170px;
  }
  .video-container .video-frame{
      width: 100%;
  }
  .iconGreen{
    color:var(--v-success-base) !important;
  }
</style>
